class EventEmitter {
    handlersMap = Object.create(null);

    $on(type, handler) {
        if (!this.handlersMap[type]) {
            this.handlersMap[type] = [];
        }
        this.handlersMap[type].push(handler);
        return this;
    }

    $off(type, handler) {
        if (this.handlersMap[type]) {
            // 这里可能有问题，不能正确的splice
            this.handlersMap[type].splice(this.handlersMap[type].indexOf(handler) >>> 0, 1);
        }
        return this;
    }

    $emit(type, ...data) {
        if (this.handlersMap[type]) {
            this.handlersMap[type].slice().forEach(handler => handler(...data));
        }
        return this;
    }
}

class WordingStorage {
    constructor() {
        this.cache = {};
    }

    setItem = (key, val) => {
        this.cache[key] = val;
    };

    getItem = key => {
        return this.cache[key];
    }
}

class WordingHandler extends EventEmitter {
    constructor() {
        super();
        this.commentCallback = null;
        this.addWordingId = '';
        this.addOffsetMeta = {};
        this.wordingStorage = new WordingStorage();
        this.patentInfo = {};
    }

    updateCommentCallback = cb => {
        this.commentCallback = cb;
    };

    updateAddWordingId = id => {
        this.addWordingId = id;
    };

    updateAddOffsetMeta = data => {
        this.addOffsetMeta = data;
    };

    updatePatentInfo = data => {
        this.patentInfo = data;
    };
}

export default new WordingHandler();
